import { render, staticRenderFns } from "./recordDialog.vue?vue&type=template&id=425a9536&scoped=true"
import script from "./recordDialog.vue?vue&type=script&lang=js"
export * from "./recordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a9536",
  null
  
)

export default component.exports